import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=3cda8e4d&"
import script from "./Button.vue?vue&type=script&setup=true&lang=js&"
export * from "./Button.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports